/**
 * Estilos compartilhados entre telas da Rede Proto.
 *
 * Só entra aqui o que mais de uma tela usa de forma idêntica — o resto continua
 * no `styles.ts` co-locado da tela.
 */
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from './theme/tokens';

export const KpiGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(4, 1fr)',
  marginBottom: '24px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const SectionSpacer = styled(Box)(() => ({
  marginTop: '24px',
}));

/** Trilho de barra de progresso (ocupação de polo, eixo de documentos). */
export const ProgressTrack = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'height',
})<{ height?: number }>(({ height = 8 }) => ({
  position: 'relative',
  height: `${height}px`,
  width: '100%',
  borderRadius: '999px',
  backgroundColor: protoColors.border,
  overflow: 'hidden',
}));

export const ProgressFill = styled('span', {
  shouldForwardProp: (prop) => prop !== 'pct' && prop !== 'color',
})<{ pct: number; color: string }>(({ pct, color }) => ({
  position: 'absolute',
  inset: 0,
  width: `${Math.min(Math.max(pct, 0), 100)}%`,
  borderRadius: '999px',
  backgroundColor: color,
}));

/** Nota de rodapé/ressalva sob um gráfico ou mapa. */
export const Note = styled('p')(() => ({
  margin: '12px 0 0',
  fontSize: '12px',
  lineHeight: 1.5,
  color: protoColors.textMuted,
}));
